import { createContext } from 'react'

export interface SiteSettings {
  heroBackgroundUrl: string | null
  pageBackgroundUrl: string | null
  birthdayReminderDays: number
}

export interface SiteSettingsContextValue {
  settings: SiteSettings
  loading: boolean
  refreshSettings: () => Promise<void>
}

export const defaultSiteSettings: SiteSettings = {
  heroBackgroundUrl: null,
  pageBackgroundUrl: null,
  birthdayReminderDays: 1,
}

export const SiteSettingsContext = createContext<SiteSettingsContextValue | undefined>(undefined)
